<template>
<div class="typography">
  <div class="categoryLandingListOuterContainer">
    <div class="container">
      <div class="categoryLandingListOuter">
        <div class="categoryLandingList">
          <button v-for="item in categories" :data-category-id="item.id" :class="{ active: currentCategory == item.id }" @click="toggleCategory(item.id)">{{ item.title }}</button>
        </div>
        <div class="blogLandingSearch">
          <fieldset class="searchBox">
            <label class="visually-hidden"><slot name="search-label"></slot></label>
            <div class="blogSearchFieldContainer">
              <input class="form-control" ref="search" name="search" id="blogSearchField" type="text" @keyup.enter="search()"/>
            </div>
            <button class="btn btn-default" @click="search()"><slot name="search-label">SEARCH</slot></button>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <div class="py-large bg-light">
    <div class="container">
      <div class="no-results" v-if="loaded && posts.length == 0">
        <slot name="no-results"></slot>
      </div>
      <div class="row gy-4">
        <div v-for="item in posts" class="col-sm-4">
          <a :href="item.link" class="promo-link-wrapper Purple">
            <div class="promo-container" :style="`background-image: url('${item.image}')`">
            </div>
            <div class="promo-content">
              {{ item.title }}
            </div>
          </a>
        </div>
      </div>
      <div v-if="totalCount > posts.length" class="mt-5 text-center">
        <button class="btn btn-default" @click="onMoreRequest">
          <slot name="load-more"></slot>
        </button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props: {
    dataSource: String,
    categoryJson: String
  },
  data() {
    return {
      currentCategory: null,
      currentPage: 1,
      totalCount: 0,
      categories: [],
      posts: [],
      loaded: false
    }
  },
  mounted() {
    this.categories = JSON.parse(this.categoryJson);
    this.readUrl();
    this.loadPosts(this.page, this.currentCategory);
  },
  methods: {
    loadPosts(page = 1, category = null, clearPosts = false) {
      if (clearPosts) {
        this.posts = [];
      }
      let postData = {
        categoryId: category ? parseInt(category) : 0,
        page: page > 1 ? page : 1,
        keyword: this.$refs.search.value
      };
      
      fetch(this.dataSource, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(postData)
      }).then((d) => d.json()).then((dj) => {
        this.page = dj.query.page;
        this.totalCount = dj.total;
        this.currentCategory = dj.query.categoryId;
        this.posts = this.posts.concat(dj.posts);
        this.loaded = true;
        this.updateUrl();
      })
    },
    search() {
      this.loadPosts(1, this.currentCategory, true);
    },
    toggleCategory(id) {
      this.loadPosts(1, this.currentCategory == id ? null : id, true);
    },
    onMoreRequest() {
      this.loadPosts(this.page + 1, this.currentCategory);
    },
    readUrl() {
      let params = new URLSearchParams(window.location.search);
      if (params.has("category")) {
        let c = this.categories.filter(cat => cat.slug == params.get("category"));
        this.currentCategory = c.length ? c[0].id : null;
      }
      if (params.has("keyword")) {
        this.keyword = parseInt(params.get("keyword"));
      }
    },
    updateUrl() {
      let params = new URLSearchParams();
      if (this.currentCategory) {
        let c = this.categories.filter(cat => cat.id == this.currentCategory);
        if (c.length) {
          params.set('category', c[0].slug);
        }
      }
      if (this.keyword) {
        params.set('keyword', this.keyword);
      }
      window.history.pushState(null, "", `${window.location.origin}${window.location.pathname}?${params.toString()}`);
    }
  }
}
</script>
